import { RouteConfig } from "vue-router";
import WizardComponent from "@/views/wizard/wizard.vue";
import { Roles } from "@/types/enums.type";

export default [
  {
    path: "/wizard",
    name: "Wizard",
    component: WizardComponent,
    meta: {
      roles: [Roles.PracticeUser],
    }
  }
] as RouteConfig[];